// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"49320af0","656":"ee019adb","703":"5fc3b0e3"}[chunkId] + ".chunk.js";
};